export const Collections = {
  USERS: "users",
  BOOKINGS: "bookings",
  SUPPORT: "support",
  GROUP_MESSAGES:"messages"
};
